module.exports = __webpack_public_path__ + "img/212.025a12a1.png";